<template>
  <b-form @submit="onSubmit" @reset="onReset">
    <div v-if="busyFetching" class="text-center">
      <i class="fa fa-4x fa-spinner fa-pulse"></i>
    </div>
    <b-tabs v-else ref="tabs">
      <b-tab v-for="coll in questionCollection" :key="coll.languageId" :title="getLangName(coll.languageId)">

        <div v-for="(question, questionIndex) in coll.questions" :key="questionIndex">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button style="text-align: left; padding-left: 20px;" block href="#" v-b-toggle="'accordion' + questionIndex" variant="info">
                {{getQuestionName(question)}}
                <b-badge style="float: right;" pill variant="danger" v-if="showBadgeForTextQuestion(coll, question)">!</b-badge>
              </b-button>
            </b-card-header>
            <b-collapse :id="'accordion' + questionIndex" accordion="question-accordion" role="tabpanel">
              <tso-module :isDefaultLanguage="coll.isDefaultLanguage"
                          :question="question"
                          :questionIndex="questionIndex"
                          :isPartOfCollection="true"
                          v-on:onDeleteQuestion="onDeleteQuestion">
              </tso-module>
            </b-collapse>
          </b-card>
        </div>
        <b-button ref="addQuestionButton"
                  variant="outline-primary"
                  style="margin:5px 0px 10px 0px; width: 100%; font-weight: bold;"
                  v-if="coll.isDefaultLanguage"
                  @click.stop="$emit('addQuestion', coll.questions)">
                  +
        </b-button>
        <b-form-group>
          <b-button type="submit" class="me-2">{{ $t('save') }}</b-button>
          <b-button type="reset" variant="danger">{{ $t('cancel') }}</b-button>
        </b-form-group>
      </b-tab>
    </b-tabs>
  </b-form>
</template>

<style scoped>
.alternatives {
  padding: 0px 5px 0px 0px;
}
.points {
  padding: 0px;
  min-width: 50px;
}
.input {
  min-width: 100px;
}
</style>

<script>
import editorFuncs from './questioneditorfuncs'
import miscFuncs from '../../../js/helpers/misc'
import TsoModule from './modules/tsomodule'

export default {
  name: 'question-editor-bp',
  components: {
    TsoModule
  },
  methods: {
    onSubmit: function(evt) {
      evt.preventDefault()
      let activeTabIndex = 0
      const tabs = document.querySelectorAll('.nav-tabs > .nav-item > .nav-link')
      if (tabs && tabs.length) {
        tabs.forEach((tabElement, i) => {
          if (tabElement.classList.contains('active')) {
            activeTabIndex = i
          }
        })
      }
      let data = this.questionCollection[activeTabIndex]
      this.$emit('formSubmitted', data)
    },
    onReset: function(evt) {
      evt.preventDefault()
      this.$router.go(-1)
    },
    showBadgeForTextQuestion(coll, question) {
      return editorFuncs.showBadgeForTextQuestion(coll, question)
    },
    getQuestionName(question) {
      return editorFuncs.getTextQuestionName(question)
    },
    onDeleteQuestion(index) {
      this.$emit('deleteQuestion', index)
    },
    getLangName: function(languageId) {
      return miscFuncs.getLangName(languageId, this.languages)
    }
  },
  props: {
    questionCollection: [],
    languages: [],
    busyFetching: false
  }
}
</script>
